import React from 'react'

import { useTranslation } from 'react-i18next'

import Divider from '@layout/Divider'
import SideNavItem from '@layout/SideNavMenu/SideNavItem'
import { useSession } from '@stores/globalData/globalData.store'

const InfoNav: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()
  if (!session.community.default_community) return null
  return (
    <>
      <Divider />
      <p className="font-medium text-base ml-2 mb-2">{t('siteSidebar.info')}</p>
      <SideNavItem
        href="/partners"
        external
        label={t('siteSidebar.partners')}
        iconName="nf-info-lt"
      />
      <SideNavItem
        href="/developers"
        external
        label={t('siteSidebar.developers')}
        iconName="nf-info-lt"
      />
    </>
  )
}

export default InfoNav
